import React, { useMemo, useState } from "react";
import { Button, Form } from "react-bootstrap";
import Spinner1 from "../common/spinners";
import { truncateText } from "../../utils/utilities";
import moment from "moment";
import InsuranceClaimModal from "../modals/InsuranceClaimModal";

const ProviderAndClaimsTable = ({ data, loading }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedData, setSelectedData] = useState();
  const itemsPerPage = 5;

  const claims = Array.isArray(data?.result) ? data.result : [];
  const filteredData = useMemo(
    () =>
      claims.filter(
        (item) =>
          item?.scheme?.name?.toLowerCase()?.includes(searchTerm.toLowerCase()) ||
          item?.description?.toLowerCase()?.includes(searchTerm.toLowerCase())
      ),
    [claims, searchTerm]
  );

  const totalPages = Math.max(1, Math.ceil(filteredData.length / itemsPerPage));
  const currentItems = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const openDetailsModal = (item) => {
    setSelectedData(item);
    setShowSummaryModal(true);
  };

  return (
    <div className="w-100">
      <div className="data-panel-head">
        <div className="data-panel-copy">
          <h5>Insurance claims</h5>
          <p>Review scheme details, covered services, and claim amounts from one cleaner table.</p>
        </div>
        <div className="data-panel-actions">
          <div className="data-search">
            <Form.Control
              type="text"
              placeholder="Search scheme or description"
              value={searchTerm}
              onChange={(event) => {
                setSearchTerm(event.target.value);
                setCurrentPage(1);
              }}
            />
          </div>
        </div>
      </div>

      <div className="data-table-shell">
        {loading ? (
          <div className="w-100 d-flex justify-content-center py-5">
            <Spinner1 />
          </div>
        ) : currentItems.length === 0 ? (
          <div className="data-table-empty">
            <h6>No claims found</h6>
            <p>Submitted insurance claims will appear here once they are available.</p>
          </div>
        ) : (
          <div className="data-table-wrap">
            <table className="table data-table align-middle w-100">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Scheme</th>
                  <th>Service</th>
                  <th>Amount</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map((item, index) => (
                  <tr key={index} onClick={() => openDetailsModal(item)} style={{ cursor: "pointer" }}>
                    <td>
                      <div className="data-cell-title">{moment(item?.createdAt).format("D MMM, YYYY")}</div>
                      <div className="data-cell-meta">{moment(item?.createdAt).format("dddd, h:mm A")}</div>
                    </td>
                    <td>
                      <div className="data-cell-title">{item?.scheme?.name ?? "---"}</div>
                      <div className="data-cell-meta">{item?.scheme?.hmoType?.name ?? "---"}</div>
                    </td>
                    <td>
                      <div className="data-cell-title">{truncateText(`${item?.description ?? "---"}`, 24)}</div>
                      <div className="data-cell-meta">{truncateText(`${item?.service?.item?.code ?? "---"}`, 15)}</div>
                    </td>
                    <td>
                      <div className="data-cell-title">
                        {item?.service?.tariff?.toLocaleString("en-NG", {
                          style: "currency",
                          currency: "NGN",
                        }) ?? "---"}
                      </div>
                    </td>
                    <td>
                      <span className={`data-status-badge ${item?.status === 1 ? "is-success" : "is-warning"}`}>
                        {item?.status === 1 ? "Settled" : "Pending"}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {!loading && filteredData.length > 0 && (
          <div className="data-pagination">
            <Button variant="light" disabled={currentPage === 1} onClick={() => setCurrentPage((page) => page - 1)}>
              Previous
            </Button>
            <span>Page {currentPage} of {totalPages}</span>
            <Button
              variant="light"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((page) => page + 1)}
            >
              Next
            </Button>
          </div>
        )}
      </div>

      <InsuranceClaimModal
        show={showSummaryModal}
        onClose={() => setShowSummaryModal(false)}
        data={selectedData}
      />
    </div>
  );
};

export default ProviderAndClaimsTable;
